/** 従業員数 */
export const enum EmployeeNumType {
  /** 1: 10人以下 */
  _1_under10 = 1,
  /** 2: 30人以下 */
  _2_under30,
  /** 3: 50人以下 */
  _3_under50,
  /** 4: 100人以下 */
  _4_under100,
  /** 5: 200人以下 */
  _5_under200,
  /** 6: 300人以下 */
  _6_under300,
  /** 7: 500人以下 */
  _7_under500,
  /** 8: 1000人以下 */
  _8_under1000,
  /** 9: 1001人以上 */
  _9_over1001,
}

export function getEmployeeNumTypeName(value: number | "") {
  switch (value) {
    case EmployeeNumType._1_under10:
      return "10人以下";
    case EmployeeNumType._2_under30:
      return "30人以下";
    case EmployeeNumType._3_under50:
      return "50人以下";
    case EmployeeNumType._4_under100:
      return "100人以下";
    case EmployeeNumType._5_under200:
      return "200人以下";
    case EmployeeNumType._6_under300:
      return "300人以下";
    case EmployeeNumType._7_under500:
      return "500人以下";
    case EmployeeNumType._8_under1000:
      return "1000人以下";
    case EmployeeNumType._9_over1001:
      return "1001人以上";

    default:
      return "";
  }
}
